import request from '@/utils/request';
export function applicationVersionList(data) {
  return request.post('admin/application-version/list', data);
}
export function applicationVersionDetail(data) {
  return request.post('admin/application-version/detail', data);
}
export function addApplicationVersion(data) {
  return request.post('admin/application-version/store', data);
}
export function applicationVersionSchedule(data) {
  return request.post('admin/application-version/schedule', data);
}
export const statusList = [{
  name: '审核中',
  id: 1
}, {
  name: '审核通过',
  id: 2
}, {
  name: '审核失败',
  id: 3
}];